import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Card, Label, Icon, Button, Message } from 'semantic-ui-react';

import Utils from 'utils/Utils.js';
import CategoryUtils from 'utils/CategoryUtils.js';
import {colors, spacings, shadow, fonts, fontSizes} from 'style';

var s = {
    content: {
        position:'relative',
        width: '100%',
        ...fonts.body,
    },
    segment: {
        position:'relative',
        backgroundColor: '#fff',
        boxShadow: shadow,
        width: '100%',
        borderRadius: spacings.tiny,
    },
    titleBar: {
        padding: spacings.small,
        height: '80px',
        fontSize: fontSizes.h4,
    },
    categoryIconSpacer: {
        float: 'right',
        display: 'inline-block',
        width: spacings.small,
    },
    categoryBadgeTitle: {
        height: '26px',
        width: '26px',
        marginRight: spacings.base,
        marginLeft: spacings.base,
        marginTop: spacings.tiny,
    },
};


const LogCard = ({t,
                  style,
                  avatarUrl,
                  open,
                  hide,
                  saving,
                  saved,
                  inline,
                  inputText,
                  categories,
                  selectedCategory,
                  onLaunch,
                  onContinue,
                  onChange,
                  onSelectCategory,
                  children}) => (
    <div style={{...s.content, ...style, ...(hide && {visibility: 'hidden'})}}>
        {!saved &&
        <div style={{...s.segment, ...(!open && {cursor:'pointer'})}} onClick={open ? null : onLaunch}>
                <div style={{...s.titleBar, color: CategoryUtils.getCategoryColor(selectedCategory.tag) || colors.themeDarkerGrey}}>
                    <div style={s.categoryIconSpacer}></div>
                    {Boolean(selectedCategory && selectedCategory.badge) &&
                        <img style={s.categoryBadgeTitle} alt='' src={selectedCategory.badge.url}></img>
                    }
                    {selectedCategory ? selectedCategory.description : ''}
                </div>
            {children}
        </div>
        }
    </div>
);
export default translate('logs')(LogCard);



// WEBPACK FOOTER //
// ./src/modules/logs/LogCard.js